<template>
	<div>
		<v-timeline v-if="length(log)" align-top dense>
			<v-timeline-item v-for="item in log" :key="`il-` + item.id" :color="getColor(item.action)" small>
				<v-row>
					<v-col cols="12" lg="4" md="6" sm="8">
						<strong>
							<span class="text-capitalize">{{ item.action }}</span>
							{{ item.created_at | timeSince }}</strong>
						<div class="text-caption">
							by {{ item.action_by }}
						</div>
					</v-col>
					<v-col class="d-inline-flex">
						<div class="text-caption align-self-center">
							{{ item.created_at | localDateTime }}
						</div>
					</v-col>
				</v-row>
				<v-divider class="mt-5" />
			</v-timeline-item>
		</v-timeline>
		<v-alert v-else class="ma-0" color="grey lighten-3">No history available for this invoice.</v-alert>
	</div>
</template>
<script>

export default {
	props: {
		log: {
			type: Array,
			default: () => [],
			required: false
		}
	},
	data () {
		return {
			//
		}
	},

	methods: {
		getColor (action) {
			if (action.includes('updated')) return 'orange'
			if (action.includes('created')) return 'green'
			if (action.includes('viewed')) return 'blue'
			if (action.includes('deleted')) return 'red'
		}
	}
}
</script>
